import { en } from "./en";
import { es } from "./es";
import { ptBR } from "./pt-BR";
import { pt } from "./pt";
import { fr } from "./fr";
import { nl } from "./nl";
import { de } from "./de";
import { it } from "./it";
import { pl } from "./pl";
import { uk } from "./uk";
import { ru } from "./ru";
import { tr } from "./tr";
import { ar } from "./ar";
import { zh } from "./zh";
import { ja } from "./ja";
import { hi } from "./hi";
import { vi } from "./vi";
import { th } from "./th";
import { id } from "./id";

const dictionaries = {
  en: en,
  es: es,
  "pt-BR": ptBR,
  pt: pt,
  fr: fr,
  nl: nl,
  de: de,
  it: it,
  pl: pl,
  uk: uk,
  ru: ru,
  tr: tr,
  ar: ar,
  zh: zh,
  ja: ja,
  hi: hi,
  vi: vi,
  th: th,
  id: id,
} as const;

export type Language = keyof typeof dictionaries;

export type LanguageOption = {
  value: Language;
  label: string;
};

export const DEFAULT_LANGUAGE: Language = "en";

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: "en", label: "🇬🇧 English" },
  { value: "es", label: "🇪🇸 Español" },
  { value: "pt-BR", label: "🇧🇷 Português (Brasil)" },
  { value: "pt", label: "🇵🇹 Português" },
  { value: "fr", label: "🇫🇷 Français" },
  { value: "nl", label: "🇳🇱 Nederlands" },
  { value: "de", label: "🇩🇪 Deutsch" },
  { value: "it", label: "🇮🇹 Italiano" },
  { value: "pl", label: "🇵🇱 Polski" },
  { value: "uk", label: "🇺🇦 Українська" },
  { value: "ru", label: "🇷🇺 Русский" },
  { value: "tr", label: "🇹🇷 Türkçe" },
  { value: "ar", label: "🇸🇦 العربية" },
  { value: "zh", label: "🇨🇳 中文" },
  { value: "ja", label: "🇯🇵 日本語" },
  { value: "hi", label: "🇮🇳 हिन्दी" },
  { value: "vi", label: "🇻🇳 Tiếng Việt" },
  { value: "th", label: "🇹🇭 ไทย" },
  { value: "id", label: "🇮🇩 Bahasa Indonesia" },
];

export type TranslationKey = keyof typeof en;

export function isSupportedLanguage(value: unknown): value is Language {
  return typeof value === "string" && value in dictionaries;
}

export class I18n {
  private language: Language;

  public constructor(language: Language) {
    this.language = language;
  }

  public setLanguage(language: Language): void {
    this.language = language;
  }

  public getLanguage(): Language {
    return this.language;
  }

  public t(key: TranslationKey): string {
    return dictionaries[this.language][key] ?? dictionaries.en[key] ?? key;
  }
}
